/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateGiddirOrderDto } from '../models/CreateGiddirOrderDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class IntegrationService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Receive blood test results from provider
     * Callback endpoint for blood test providers (e.g. Giddir) to push results.
     * @param provider
     * @returns any
     * @throws ApiError
     */
    public callback(
        provider: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/integration/{provider}/callback',
            path: {
                'provider': provider,
            },
        });
    }

    /**
     * Get patient bookings from Hlthy
     * Fetches booking information for the authenticated patient from Hlthy API
     * @returns any Patient bookings retrieved successfully
     * @throws ApiError
     */
    public getPatientBookings(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/integration/hlthy/booking/patient',
            errors: {
                400: `Bad request - user has no hlthyId`,
                401: `Unauthorized - no valid authentication`,
            },
        });
    }

    /**
     * Create a Giddir blood test referral for a patient
     * Creates a blood test order via Giddir for the specified patient. Verifies that the authenticated medstaff has access to the patient.
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public createGiddirTestOrder(
        requestBody: CreateGiddirOrderDto,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/integration/giddir/create-referral',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
